export default {
  pyamentRequestRejected:
    "It seems that you have cancelled your transaction request.",
  cnacledSigninRequest: "It seems that you have cancelled sign in request.",
  insufficient_funds:
    "It seems that you have insufficient funds in your wallet.",
  invalid_network:
    "It seems that you are using the wrong network to connect. Please shift to Ethereum Mainnet Network.",
  approval_request_rejected: "Please provide approval signature to continue",
  event_not_started: "Event has not started yet! Please wait",
  payment_request_rejected: "Please approve payment request to continue",
  selected_payment_disabled: "Currently selected payment method is disabled. ",
  something_wrong:" Oops! Something Went Wrong. Please try again or check your internet connection!"
};
